 /* # FAV label for Owl buttons */
function labelOwlButtons() {
    document.querySelectorAll('.owl-prev').forEach(function (btn) {
        btn.setAttribute('aria-label', 'Previous slide');
    });

    document.querySelectorAll('.owl-next').forEach(function (btn) {
        btn.setAttribute('aria-label', 'Next slide');
    });
}

labelOwlButtons();
setTimeout(labelOwlButtons, 500);
setTimeout(labelOwlButtons, 1500);
setTimeout(labelOwlButtons, 3000);
 /* # FAV label for Owl buttons END */